module.exports = __webpack_public_path__ + "static/Glenn.773dfefc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Glenn.jpg
// module id = 459
// module chunks = 35783957827783